(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-account-portal"] && !Shopify.designMode) return;
  try {
    
  const portal = document.querySelector('[data-customer-portal]');

  if (portal) {
    const orderSelect = portal.querySelector('[data-warranty-order-select]');
    const productSelect = portal.querySelector('[data-warranty-product-select]');
    const productOptions = productSelect ? Array.from(productSelect.options) : [];

    const filterProducts = () => {
      const selected = orderSelect.selectedOptions[0];
      const orderId = selected ? selected.dataset.orderId : '';

      productOptions.forEach((option) => {
        const shouldShow = !option.dataset.orderId || option.dataset.orderId === orderId;
        option.hidden = !shouldShow;
      });

      productSelect.value = '';
    };

    if (orderSelect && productSelect) {
      orderSelect.addEventListener('change', filterProducts);
      filterProducts();
    }

    portal.querySelectorAll('[data-warranty-order]').forEach((button) => {
      button.addEventListener('click', () => {
        const orderId = button.dataset.warrantyOrder;

        if (orderSelect) {
          Array.from(orderSelect.options).forEach((option) => {
            option.selected = option.dataset.orderId === orderId;
          });
          orderSelect.dispatchEvent(new Event('change'));
        }

        const warranty = document.getElementById('warranty');
        if (warranty) {
          warranty.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.querySelectorAll('[data-nexus-cookie-preferences]').forEach((button) => {
    button.addEventListener('click', async () => {
      const status = button.parentElement.querySelector('[data-nexus-cookie-status]');
      status.textContent = '';
      try {
        if (!window.privacyBanner?.showPreferences) throw new Error();
        await window.privacyBanner.showPreferences();
      } catch {
        status.textContent = status.dataset.error;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexus-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-nexus-hero-slider]').forEach((hero) => {
      const slides = Array.from(hero.querySelectorAll('[data-nexus-hero-slide]'));
      const dotsContainer = hero.querySelector('[data-nexus-hero-dots]');
      const toggle = hero.querySelector('[data-nexus-hero-toggle]');
      const liveRegion = hero.querySelector('.nexus-hero__slides');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const delay = Number(hero.dataset.delay) || 6000;
      let activeIndex = 0;
      let timer;
      let paused = hero.dataset.autoplay !== 'true' || motion.matches;
      let hovered = false;

      if (slides.length < 2) {
        hero.querySelector('.nexus-hero__controls')?.remove();
        return;
      }

      const dots = slides.map((slide, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'nexus-hero__dot';
        dot.setAttribute('aria-label', hero.dataset.promotionLabel.replace('__NUMBER__', index + 1));
        dot.addEventListener('click', () => {
          paused = true;
          showSlide(index);
          syncPlayback();
        });
        dotsContainer.append(dot);
        return dot;
      });

      function showSlide(index) {
        activeIndex = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === activeIndex;
          slide.classList.toggle('is-active', active);
          slide.inert = !active;
          slide.setAttribute('aria-hidden', String(!active));
        });
        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === activeIndex);
          dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
        });
      }

      function syncPlayback() {
        window.clearInterval(timer);
        toggle.textContent = paused ? hero.dataset.playLabel : hero.dataset.pauseLabel;
        liveRegion.setAttribute('aria-live', paused ? 'polite' : 'off');
        if (!paused && !hovered) {
          timer = window.setInterval(() => showSlide(activeIndex + 1), delay);
        }
      }

      toggle.addEventListener('click', () => {
        paused = !paused;
        syncPlayback();
      });
      hero.addEventListener('mouseenter', () => {
        hovered = true;
        syncPlayback();
      });
      hero.addEventListener('mouseleave', () => {
        hovered = false;
        syncPlayback();
      });
      hero.addEventListener('focusin', (event) => {
        if (event.target === toggle) return;
        paused = true;
        syncPlayback();
      });
      motion.addEventListener('change', () => {
        if (motion.matches) {
          paused = true;
          syncPlayback();
        }
      });
      showSlide(0);
      syncPlayback();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
